module.exports = __webpack_public_path__ + "img/华章LOGO.5c16aa0e.png";